import { Link } from "react-router-dom";
import { Col, Container, Row } from "reactstrap";
import { CityTitle } from "../../../constants";
import { CityData } from "../../../data/demo/PropertyDemo2";
import { routes } from "../../../routers/routes";
import { dynamicImage } from "../../../utils";
import RatioImage from "../../../utils/RatioImage";
import CommonHeader from "../common/CommonHeader";

const City = () => {
  return (
    <section className="section-t-lg-space property2-city-section section-b-lg-space">
      <Container>
        <CommonHeader title={CityTitle} headClass="title-style-1 title-style-6" subClass="horizontal-title" url={routes.Property.Grid.Property3Grid} view />
        <Row className="gy-xl-0 gy-md-4 g-3 justify-content-center ratio_125">
          {CityData.map((item, index) => (
            <Col lg="3" xs="6" key={index}>
              <Link to={routes.Property.Grid.Property3Grid} className="city-box">
                <div className="city-img">
                  <RatioImage src={dynamicImage(`property2/city/${item.image}`)} alt={`c-${index + 1}`} className="bg-img" />
                </div>
                <div className="city-content">
                  <h4>{item.title}</h4>
                  <h6>{item.text}</h6>
                </div>
              </Link>
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
};

export default City;
